import { startWith, map } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TagDto } from './../../../../../data-transfer/entities/tag-dto';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TagsDialogComponent } from 'src/app/components/various-components/tags/tags-dialog/tags-dialog.component';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { TagApiService } from 'src/app/data-transfer/services/tag-api-service';
import { DialogActions } from 'src/app/model/dictionary';

@Component({
  selector: 'app-select-tags-dialog',
  templateUrl: './select-tags-dialog.component.html',
  styleUrls: ['./select-tags-dialog.component.scss'],
})
export class SelectTagsDialogComponent implements OnInit, OnDestroy {
  @ViewChild('tagInput') tagInput!: ElementRef<HTMLInputElement>;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  tagCtrl!: FormControl;

  allTagNames: string[] = [];

  allTags: TagDto[] = [];
  selectedTags: TagDto[] = [];
  filteredTags!: Observable<TagDto[]>;
  component: any = null;

  private saveSubscription?: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private tagApiService: TagApiService,
    private dialogRef: MatDialogRef<SelectTagsDialogComponent>,
    private dialog: MatDialog
  ) {
    this.allTags = this.data.tags;
    this.component = this.data.item;
    this.selectedTags = this.allTags.filter(tag => this.component?.associatedTagIdentifiers.includes(tag.id) ?? false);
  }

  ngOnInit(): void {
    this.tagCtrl = new FormControl('');
    this.allTagNames = this.allTags.map((tag: TagDto) => tag.name);

    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.name)),
      map(searchValue => {
        const filtered = searchValue
          ? this._filter(searchValue)
          : this.allTags.filter(pr => this.selectedTags.find(tag => tag.name === pr.name) == null).slice();
        const unusedTags = this.allTags.filter(principal => this.selectedTags.find(tag => tag.name === principal.name) == null);
        if(filtered.length === 0 && unusedTags.length > 0) {
          this.tagCtrl.setErrors({'noResult': true});
        }
        return filtered;
      })
    );
  }

  async onSubmit() {
    this.dialogRef.close(this.selectedTags.map(tag => tag.id));
  }

  async createTag(event: Event) {
    event.stopPropagation();
    const dialogConfig = getDialogConfig({ allTagNames: this.allTagNames });
    dialogConfig.disableClose = true;
    const dialogRef = this.dialog.open(TagsDialogComponent, dialogConfig);
    const dialogResult = await dialogRef.afterClosed().toPromise();
    if (dialogResult.event === DialogActions.REJECT) {
      return;
    }
    const tagDto: TagDto = dialogResult.data;
    tagDto.isDefault = false;
    this.saveSubscription = this.tagApiService.saveTag(tagDto).subscribe(newId => {
      tagDto.id = newId;
      this.allTags.push(tagDto);
      this.tagInput.nativeElement.value = '';
      this.tagCtrl.setValue('');
      this.allTagNames = this.allTags.map((tag: TagDto) => tag.name);
    });
  }

  removeTag(tag: TagDto): void {
    const index = this.selectedTags.indexOf(tag);
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
      this.tagInput.nativeElement.value = '';
      this.tagCtrl.setValue('');
    }
  }

  addTag(tag: TagDto): void {
    this.selectedTags.push(tag);
    this.tagInput.nativeElement.value = '';
    this.tagCtrl.setValue('');
  }

  private _filter(value: string): TagDto[] {
    const filterValue = value.toLowerCase();
    const filteredTags = this.allTags.filter(principal => this.selectedTags.find(tag => tag.name === principal.name) == null);
    return filteredTags.filter(tag => tag.name.toLowerCase().includes(filterValue));
  }

  ngOnDestroy(): void {
    this.saveSubscription?.unsubscribe();
  }
}
